"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DispenseScan = void 0;
const core_1 = require("@material-ui/core");
const ndc_barcode_scan_1 = require("client/components/ndc-barcode-scan");
const mobx_react_1 = require("mobx-react");
const ramda_1 = require("ramda");
const React = require("react");
const styles = core_1.createStyles({});
const decorate = core_1.withStyles(styles);
let DispenseScanUnstyled = class DispenseScanUnstyled extends React.Component {
    constructor() {
        super(...arguments);
        this.handleSubmit = async (scannedList) => {
            const dispenseScanData = scannedList.map(data => {
                const [ndc, scannedArray] = data;
                const byLotNumber = ramda_1.groupBy((barcodeData) => barcodeData.lot);
                const scannedDataGroupedByLot = byLotNumber(scannedArray);
                return [ndc, Object.entries(scannedDataGroupedByLot)];
            });
            await this.props.handleSubmit(dispenseScanData);
        };
    }
    render() {
        return (React.createElement(ndc_barcode_scan_1.NdcBarcodeScan, { onCancel: this.props.onCancel, onSubmit: this.handleSubmit }));
    }
};
DispenseScanUnstyled = __decorate([
    mobx_react_1.observer
], DispenseScanUnstyled);
exports.DispenseScan = decorate(DispenseScanUnstyled);



//////////////////
// WEBPACK FOOTER
// ./src/client/modules/orders/modules/orders-detail/components/dispense-scan/dispense-scan.tsx
// module id = 3751
// module chunks = 0